import {makeReactContext} from 'lib/makeReactContext';

import {FlowchartEditorMode} from './ProcessFlowchartEditorModeConstants';

export const FlowchartEditorModeContext = makeReactContext<FlowchartEditorMode>(
  () => FlowchartEditorMode.MAIN_CANVAS,
  'FlowchartEditorModeContext'
);
